// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import { DateTime } from 'luxon';
function MetricSelectorSearchItem({ handleAdd, metric, selected }) {
  return (
    <tr>
      <td>
        {selected ?
          <i className="ion ion-ios-checkmark"/> 
          :
          null 
        } 
      </td>
      <td className="_10">{metric.order}</td>
      <td className="_70"><a target="_blank" className="metric-title" href={`${window.authoringUrl}/metrics/${metric._id}`}>{metric.title}</a></td>
      {/* <td><em>Survey: {metric.survey ? "SURVEY" : ""}</em></td> */}
      
      <td className="_10">{DateTime.fromISO(metric.updated).toLocaleString(DateTime.DATE_SHORT)}</td>
      <td className="_10">
        <button 
          style={{width: '95px'}}
          className="yt-btn info small"
          disabled={selected}
          onClick={handleAdd}
          type="button"
        >
          {selected ? '    Added    ' : 'Add metric'}
        </button>
      </td>
    </tr>
  )
}

MetricSelectorSearchItem.propTypes = {
  handleAdd: PropTypes.func.isRequired
  , metric: PropTypes.object.isRequired
  , selected: PropTypes.bool 
}

MetricSelectorSearchItem.defaultProps = {
  selected: true // set to true by default to prevent double-adding before the lists load 
}

export default MetricSelectorSearchItem;



// WEBPACK FOOTER //
// modules/metric/components/MetricSelectorSearchItem.js.jsx